export default __webpack_public_path__ + "static/media/5_3_logo.3b081481.png";